import { environment } from '../../../environments/environment';

export class Endpoints {
  public static readonly LIST_PREFIX_ENDPOINT: string = environment.awsBaseUrl + 'mega/list-prefix';
  public static readonly SETTLE_DATE_INFO_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/settle-date-info';
  public static readonly MEGA_COMMIT_ENDPOINT: string = environment.awsBaseUrl + 'mega/commit';
  public static readonly MEGA_CALCULATE_FEE_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/calc-fee';
  public static readonly MEGA_LIST_COMMITTED: string =
    environment.awsBaseUrl + 'mega/list-committed';
  public static readonly MEGA_LIST_SETTLED: string = environment.awsBaseUrl + 'mega/list-settled';
  public static readonly MEGA_RETRIEVE_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/retrieve-mega';
  public static readonly MEGA_DOWNLOAD_PDF_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/download-mega-info';
  public static readonly MEGA_COLLATERAL_UPLOAD_SIGNED_URL_ENDPOINT: string =
    environment.awsBaseUrl + 'collateral/signed-url';
  public static readonly MEGA_MONTHLY_VOLUME_SUMMARY: string =
    environment.awsBaseUrl + 'mega/monthly-volume-summary';
  public static readonly MEGA_DASHBOARD_STATUS_SUMMARY_FOR_COUNT: string =
    environment.awsBaseUrl + 'collateral/status-summary';
  public static readonly MEGA_DASHBOARD_UPCOMING_MEGA_SETTLEMENTS: string =
    environment.awsBaseUrl + 'mega/upcoming-settlements';
  public static readonly MEGA_POOL_COLLATERAL_DUE: string =
    environment.awsBaseUrl + 'mega/collateral-due';
  public static readonly UPLOAD_POOL_INFO_UPLOAD_LOCATION_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/upload-location';
  public static readonly UPLOAD_POOL_INFO_CANCEL_UPLOAD_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/cancel';
  public static readonly UPLOAD_POOL_INFO_DOWNLOAD_XLSX_TEMPLATE: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/download-template';
  public static readonly UPLOAD_POOL_INFO_UPLOAD_STATUS_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/upload-status';
  public static readonly UPLOAD_POOL_INFO_VALIDATION_STATUS_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/validation-status';
  public static readonly ALLOCATE_POOL_VALIDATED_MEGA_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/validated-megas';
  public static readonly ALLOCATE_COLLATERAL_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/collateral-allocation';
  public static readonly DEALLOCATE_COLLATERAL_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/collateral/deallocation';
  public static readonly DEALLOCATE_FREDDIE_COLLATERAL_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/deallocate-fre-colts';
  public static readonly UPLOAD_POOL_INFO_COMMIT_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/commit';
  public static readonly UPLOAD_POOL_INFO_COMMIT_ALLOCATION_STATUS_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/allocation-status';
  public static readonly UPLOAD_POOL_INFO_DOWNLOAD_ERROR_REPORT_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/download-validation-result';
  public static readonly MULTI_MEGA_CALCULATE_FEE_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/multi-calc-fee';
  public static readonly CU_MULTI_MEGA_CALCULATE_FEE_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/cu-multi-calc-fee';
  public static readonly CU_MULTI_COMMIT_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/cu-multi-mega-commit';
  public static readonly MULTI_MEGA_VALIDATE_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/multi-mega-validation';
  public static readonly MULTI_MEGA_COMMIT_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/multi-mega-commit';
  public static readonly MULTI_MEGA_EXPORT_PDF_CONFIRMATION_DETAIL_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/download-multimega-info';
  public static readonly MULTI_MEGA_EXPORT_EXCEL_CONFIRMATION_DETAIL_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/download-multimega-info-excel';
  public static readonly COLLATERAL_ANALYZER_VALIDATE_COLLATERAL_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/validate-collateral';
  public static readonly COLLATERAL_ANALYZER_CHECK_FACTOR_DATA_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/check-factor-data';
  public static readonly COLLATERAL_ANALYZER_DOWNLOAD_EXCEL_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/collateral-excel';
  public static readonly COLLATERAL_ANALYZER_DOWNLOAD_PDF_ENDPOINT: string =
    environment.awsBaseUrl + 'mega/download-mega-info';
  public static readonly COLLATERAL_ANALYZER_DISCLOSURE_TEMPMEGA_ENDPOINT: string =
    environment.awsdisclosureBaseUrl + 'disclosure/temp-mega';
  public static readonly ONPREM_COLLATERAL_ANALYZER_DISCLOSURE_TEMPMEGA_ENDPOINT: string =
    environment.disclosureBaseUrl + 'disclosure/temp-mega';
  public static readonly COLLATERAL_ANALYZER_DISCLOSURE_WADETAILS_ENDPOINT: string =
    environment.awsdisclosureBaseUrl + 'disclosure/details';
  public static readonly ONPREM_COLLATERAL_ANALYZER_DISCLOSURE_WADETAILS_ENDPOINT: string =
    environment.disclosureBaseUrl + 'disclosure/details';
  public static readonly COLLATERAL_ANALYZER_DISCLOSURE_STATISTICS_ENDPOINT: string =
    environment.awsdisclosureBaseUrl + 'disclosure/statistics';
  public static readonly ONPREM_COLLATERAL_ANALYZER_DISCLOSURE_STATISTICS_ENDPOINT: string =
    environment.disclosureBaseUrl + 'disclosure/statistics';
  public static readonly COLLATERAL_ANALYZER_DISCLOSURE_QUARTILE_ENDPOINT: string =
    environment.awsdisclosureBaseUrl + 'disclosure/quartiles';
  public static readonly ONPREM_COLLATERAL_ANALYZER_DISCLOSURE_QUARTILE_ENDPOINT: string =
    environment.disclosureBaseUrl + 'disclosure/quartiles';
  public static readonly COLLATERAL_ANALYZER_DISCLOSURE_DELETE_TEMPMEGA_ENDPOINT: string =
    environment.awsdisclosureBaseUrl + 'disclosure/delete-temp-mega';
  public static readonly ONPREM_COLLATERAL_ANALYZER_DISCLOSURE_DELETE_TEMPMEGA_ENDPOINT: string =
    environment.disclosureBaseUrl + 'disclosure/delete-temp-mega';
  public static readonly UPLOAD_POOL_INFO_UPLOAD_COLLATERAL_ANALYZER_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/upload-collateral-details';
  public static readonly DOWNLOAD_COLLATERAL_POOL_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/download-collateral-details';
  public static readonly COLLATERAL_ANALYZER_DISCLOSURE_ANALYTICS_ENDPOINT: string =
    environment.awsdisclosureAnalyticsBaseUrl + 'disclosurePreview';
  public static readonly ONPREM_COLLATERAL_ANALYZER_DISCLOSURE_ANALYTICS_ENDPOINT: string =
    environment.disclosureAnalyticsBaseUrl + 'disclosurePreview';
}
